<template>
    <div>
        <div>
            <v-card class="px-5 mt-5 text-center" elevation="5" :loading="isLoading">
                <data-table
                        :orderBy="tableProps.column"
                        :orderDir="tableProps.dir"
                        :data="data"
                        :columns="columns"
                        :debounce-delay="3000"
                        :pagination="paginate"
                        :translate="translate"
                        :per-page="[10, 25, 50, 100, 500]"
                        @on-table-props-changed="reloadTable"
                        :loading="true"
                        class="pt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
                >
                </data-table>
            </v-card>
        </div>
    </div>
</template>

<script>
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import {dataTableProps} from "@/main";
import {debounce} from "../../../custom";
import button from "@/view/pages/button";

export default {
    name: "showOwnNum",
    components: {TitleRibbon},
    props: {
        uniquePack: {
            default: '',
            require: true
        },
        modal: {
            default: false,
        },
    },
    data() {
        return {
            translate: dataTableProps.translate,
            paginate: dataTableProps.pagination,
            tableProps: dataTableProps.tableProps,
            columns: [
                {
                    label: '<input type="checkbox" id="selectAll">',
                    transform: (val) => {
                        return `<input type="checkbox"  data-id="${val.data.phone}">`
                    },
                    orderable: false,
                },
                {
                    label: 'ردیف',
                    transform: (val) => {
                        let row = this.data.current_page - 1;
                        row = row * this.data.per_page;
                        return row + val.row + 1;
                    },
                    orderable: true,
                },
                {
                    label: 'شناسه',
                    name: 'id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'شماره',
                    name: 'phone',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'کارتن',
                    name: 'carton',
                    transform: (val) => {
                        return val.data.carton ? val.data.carton : 'وجود ندارد';
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'پک',
                    name: 'pack',
                    transform: (val) => {
                        return val.data.pack ? val.data.pack : '-';
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'پوکه',
                    name: 'pocket',
                    transform: (val) => {
                        return val.data.pocket ? val.data.pocket : 'ندارد'
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'مدیریت',
                    name: 'action',
                    component: button,
                    handler: this.actions,
                    event: "actions",
                    meta: {
                        buttons: [
                            {
                                name: 'delete',
                                label: 'حذف شماره',
                                icon: 'trash-alt',
                                class: 'btn-outline-danger',
                                action: this.actions,
                                status: 'divar_delete',
                                condition: this.buttonsCondition
                            },
                            {
                                name: 'login',
                                label: 'مشاهده توکن شماره',
                                icon: 'eye',
                                class: 'btn-outline-primary',
                                action: this.actions,
                                condition: () => {
                                    return true;
                                }
                            },
                        ]
                    }
                }
            ],
            isLoading: false,
            data: {},
            url: `${url}/admin/monitoring/packs/${this.uniquePack}`,
        }
    },
    methods: {
        getDataForTable(url = this.url, query = this.tableProps) {
            const vm = this
            vm.isLoading = true;
            $.ajax({
                url: url,
                type: 'GET',
                fn: this.getDataForTable,
                data: query,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: function (data) {
                    vm.data = data.data;
                    vm.isLoading = false;
                }
            })
        },
        actions(data, type) {
            if (type === 'delete') {
                this.$modal.yesNo("تایید حذف!", "آیا از حذف این شماره اطمینان دارید؟").then((value) => {
                    if (value === true)
                        $.ajax({
                            url: `${url}/admin/monitoring/packs/single/${data.id}`,
                            method: "DELETE",
                            headers: {
                                'Authorization': Token,
                                ACCEPT: 'application/json',
                                "Content-Type": "application/json"
                            },
                            msg: true,
                            success: () => {
                                this.reloadTable();
                            }
                        })
                })
            } else if (type === 'login') {
                $.ajax({
                    url: `${url}/admin/fresh`,
                    type: 'POST',
                    data: JSON.stringify({'token': data.login.split("=")[1]}),
                    headers: {
                        "ACCEPT": "application/json",
                        "Authorization": Token,
                        "Content-Type": "application/json"
                    },
                    msg: false,
                    success() {
                        window.open(data.login, '_blank');
                    }
                });
            }
        },
        reloadTable(tableProps) {
            debounce(() => {
                this.getDataForTable(this.url, tableProps);
            }, 1000);
        },
        seeToken(value) {
            console.log(value);
            // window.open(value, '_blank');
        },
        buttonsCondition(status) {
            return [
                "حذف شده",
            ].indexOf(status) <= -1;
        }
    },
    watch: {
        uniquePack: function () {
            this.getDataForTable();
        }
    },
    mounted() {
        this.getDataForTable(this.url)

        $(document).on('click', '#selectAll', (element) => {
            if ($(element.target).is(':checked')) {
                $('input[type="checkbox"]').prop('checked', true);

                const selected = $('input[type="checkbox"]').map(function () {
                    return $(this).data('id')
                }).get();

                this.selectedNumber = selected;
            } else {
                $('input[type="checkbox"]').prop('checked', false)
                this.selectedNumber = []
            }
        })
    },
}
</script>

<style scoped>

</style>